export default __webpack_public_path__ + "img/dcdbd3e18347adc8b7afa2d3aa218514.svg";